// eslint-disable-next-line no-restricted-imports
import { AvailableLegalClientStatusesQuery } from 'api/generated/graphql';
import { AvailableClientStatusesData } from 'api/types/data';
import { LegalClientOnboardingStatusType } from 'api/types/entity';
import { lodash } from 'helpers';

import { parseLegalClientAccountStatus } from './parseEntity/parseLegalClientAccountStatus';
import { parseLegalClientOnboardingStatus } from './parseEntity/parseLegalClientOnboardingStatus';

export const parseAvailableLegalClientStatusesData = (
  data: AvailableLegalClientStatusesQuery | undefined
): AvailableClientStatusesData<LegalClientOnboardingStatusType> | undefined =>
  data
    ? {
        account: data.availableClientStatuses?.account
          ? lodash.compact(
              data.availableClientStatuses.account.map(
                parseLegalClientAccountStatus
              )
            )
          : [],
        onboarding: data.availableClientStatuses?.onboarding
          ? lodash
              .compact(data.availableClientStatuses.onboarding)
              .map(parseLegalClientOnboardingStatus)
          : [],
      }
    : undefined;
